export const isLocalHost = () => /^dev/.test(window.location.hostname);
